import { styled } from "styled-components";

export const SearchFilterContainer = styled.div`
  position: relative;
  .input-search {
    border: none;
    border-bottom: 1px solid #8e8e8e;
    background: #fff;
    color: #000;
    /* width: 100%; */

    &:focus-visible {
      border: none;
      border-bottom: 1px solid #8e8e8e;
      outline: none;
    }
  }
  .customSearchModel {
    position: absolute;
    top: 138%;
    left: 0;
    background-color: #fff;
    color: #000;
    width: 250px;
    z-index: 1;
    padding: 8px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    ul {
      height: 100px;
      overflow-y: scroll;
      padding-left: 10px;
      list-style-type: none;
      .MuiFormControlLabel-root span {
        padding: 0;
        &:first-child {
          margin-right: 5px;
        }
      }
    }
    .SearchFilterModelFooter {
      display: flex;
      align-items: center;
      justify-content: space-between;
      /* border-top: 1px solid #909090; */
      padding-top: 5px;
      .text-btn {
        color: #00a4e5;
        font-weight: 600;
        background-color: transparent;
        cursor: pointer;
        padding: 0;
      }
      .text-btn.kp-btn {
        background-color: #00a4e5;
        color: #fff;
        padding: 2px 8px;
      }
    }
  }

  .MuiTypography-root {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;
